import type { ReactNode } from 'react'

import { useTexte } from '../texte'
import { XIcon } from './Icons'

/**
 * The head of a sheet: the title, what else belongs up there, and the
 * close button (1.153.0, review C10).
 *
 * Until then this stood in twenty-five sheets, fifteen of them line for
 * line the same, two with their own class and an `h2` -- the kind of copy
 * that 1.61.0 collected for the sheets themselves. A head that gains a
 * thing (a back arrow, a size) would have gained it in one sheet and not
 * in the other twenty-four. What differs stays with the caller: the title
 * (a node, so the spot's sign fits in), the buttons between title and
 * close (`children`: the pager of the point, "Karte groß" of the form), and
 * a close label that names the sheet where the plain word would not do.
 */
export function Blattkopf({
  titel,
  onSchliessen,
  children,
  schliessenLabel,
}: {
  titel: ReactNode
  onSchliessen: () => void
  children?: ReactNode
  /** The accessible name of the close button; the plain word by default. */
  schliessenLabel?: string
}) {
  const schliessen = useTexte().allgemein.schliessen
  return (
    <div className="bogen__kopf">
      <h3 className="bogen__titel">{titel}</h3>
      {children}
      <button
        type="button"
        className="icon-button"
        onClick={onSchliessen}
        aria-label={schliessenLabel ?? schliessen}
        title={schliessen}
      >
        <XIcon size={18} />
      </button>
    </div>
  )
}
